/*
 * Copyright (c) 2020. American Express Company
 */

export class InterfaceActionTypeModel {
    id: number;
    name: string;
    description: string;
    slug: string;
    action?: () => void;
    created: string;
    updated: string;
}
